import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('impression')
  .factory()

export {
  Provider as ImpressionReportProvider,
  useStore as useImpressionReportStore,
}
